// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.box_product_container img {
  aspect-ratio: 3/2;
  object-fit: contain;
}

.products_edit ul {
  transition: all 0.5s ease-in-out;
}
.products_edit ul:hover {
  background-color: rgba(168, 168, 168, 0.158);
}
.box_product_container {
  overflow-y: auto;
  max-width: 100%;
}

.link_products_box_component:hover {
  text-decoration: none;
}
.product_price_code_box{
  display: flex;
  width: 100%;
  flex-direction: row;
  font-weight: bold;
  color: var(--ColorSecondaryDark);
}

.product_code_box{
  opacity: 0.6;
}`, "",{"version":3,"sources":["webpack://./src/components/productsComponent/products.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,YAAY;AACd","sourcesContent":[".box_product_container img {\n  aspect-ratio: 3/2;\n  object-fit: contain;\n}\n\n.products_edit ul {\n  transition: all 0.5s ease-in-out;\n}\n.products_edit ul:hover {\n  background-color: rgba(168, 168, 168, 0.158);\n}\n.box_product_container {\n  overflow-y: auto;\n  max-width: 100%;\n}\n\n.link_products_box_component:hover {\n  text-decoration: none;\n}\n.product_price_code_box{\n  display: flex;\n  width: 100%;\n  flex-direction: row;\n  font-weight: bold;\n  color: var(--ColorSecondaryDark);\n}\n\n.product_code_box{\n  opacity: 0.6;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
